import React, { useContext, useMemo, useState } from 'react'
import { useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { addLocale } from 'primereact/api';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types'
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';
import { ProgressSpinner } from 'primereact/progressspinner';
import { saveAs } from 'file-saver';
import '../../DataTableDemo.css';
import dateFormat from '../../services/DateFormat.service';
import apis from '../../api';
import { useRef } from 'react';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import useWindowDimensions from '../hooks/useDimensions';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toolbar as BigToolbar } from 'react-big-calendar/lib/Toolbar';
import InfoIcon from '../InfoIcon/InfoIcon';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './TeamWeek.css'
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import useParamsTracking from '../../helpers/useParamsTracking';
import { SplitButton } from 'primereact/splitbutton';
import useParamsProgram from '../../helpers/useParamsProgram';
import useParamsNoProgram from '../../helpers/useParamsNoProgram';
import checkExcelData from '../../services/checkExcel.service';
import useParamsNoTurn from '../../helpers/useParamsNoTurn';
import { excelReport } from '../../services/excelReport.service';
import { InputTextarea } from 'primereact/inputtextarea';
import useParamsActivities from '../../helpers/useParamsActivities';
import { TablePaginator } from '../TablePaginator/TablePaginator';

const TeamWeek = () => {

    const [fechaInicio, setFechaInicio] = useState(new Date(Date.now()))
    const [fechaInicioCalendario, setFechaInicioCalendario] = useState(new Date(Date.now()))
    const [novedadesCalendario, setNovedadesCalendario] = useState([])
    const [novedades, setNovedades] = useState([])
    const [turnos, setTurnos] = useState([])
    const [listaTurnos, setListaTurnos] = useState([])
    const [listaTurnosFilter, setListaTurnosFilter] = useState([])
    const [semanas, setSemanas] = useState([])
    const [contratos, setContratos] = useState()
    const { width, height } = useWindowDimensions()

    const [turno, setTurno] = useState({})
    const [semana, setSemana] = useState({
        WEEK: "",
        INIT_DT_WEEK: "",
        END_DT_WEEK: "",
        index: ""
    })
    const [rowsTurno, setRowsTurno] = useState([])
    const [nombre, setNombre] = useState("")
    const [fechas, setFechas] = useState("")
    const [shifts, setShifts] = useState("")
    const [year, setYear] = useState("")

    const [costCenter, setCostCenter] = useState({})
    const [invoiceCostCenter, setInvoiceCostCenter] = useState({})
    const [costCenterList, setCostCenterList] = useState("")
    const [invoiceCostCenterList, setInvoiceCostCenterList] = useState("")

    const [days, setDays] = useState({
        Lunes: "",
        Martes: "",
        "Miércoles": "",
        Jueves: "",
        Viernes: "",
        "Sábado": "",
        Domingo: ""
    })

    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loading4, setLoading4] = useState(false)
    const [loading6, setLoading6] = useState(false)
    const [loading7, setLoading7] = useState(false)
    const [loading10, setLoading10] = useState(false)
    const [consultado, setConsultado] = useState(0)
    const [consultado2, setConsultado2] = useState(false);
    const [consultado3, setConsultado3] = useState(false);
    const [loadPage, setLoadPage] = useState(false)
    const [loadReplace, setLoadReplace] = useState(false)
    const [loadingReplace, setLoadingReplace] = useState(false)
    const [loading5, setLoading5] = useState(false)
    const [loading8, setLoading8] = useState(false)
    const [loading9, setLoading9] = useState(false)

    const [isOpenAgregar, setIsOpenAgregar] = useState(false)
    const [isOpenVer, setIsOpenVer] = useState(false)
    const [isOpenEliminar, setIsOpenEliminar] = useState(false)
    const [isOpenCargue, setIsOpenCargue] = React.useState(false);
    const [isOpenCargueDel, setIsOpenCargueDel] = React.useState(false);
    const [isOpenReplace, setIsOpenReplace] = React.useState(false);
    const [isOpenReplaceDate, setIsOpenReplaceDate] = useState(false)
    const [isOpenCargueMarking, setIsOpenCargueMarking] = React.useState(false);
    const [isOpenAdd, setIsOpenAdd] = React.useState(false);
    const [employees, setEmployees] = useState('')

    const [replaceContracts, setReplaceContracts] = useState([])
    const [replaceInfo, setReplaceInfo] = useState([])
    const [replaceContract, setReplaceContract] = useState("")
    const [replaceCause, setReplaceCause] = useState("")
    const [replaceStart, setReplaceStart] = useState(new Date(Date.now()))
    const [replaceEnd, setReplaceEnd] = useState(new Date(Date.now()))
    const [replaceType, setReplaceType] = useState("")
    const [replaceShiftsList, setReplaceShiftsList] = useState([])
    const [replaceShifts, setReplaceShifts] = useState([])
    const [holidayList, setHolidayList] = useState([])
    const [holidayType, setHolidayType] = useState("")

    const [clientList, setClientList] = useState(false)
    const [entityList, setEntityList] = useState(false)
    const [client, setClient] = useState("")
    const [entity, setEntity] = useState("")
    const [loadingAdd, setLoadingAdd] = useState("")
    const [rowState, setRowState] = useState({});

    const toast = useRef(null);
    const fileUploadRef = useRef(null);
    const elementWidth = { width: "12rem" }
    const headers = {
        authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json; charset=UTF-8'
    }

    let sixDate = new Date(Date.now())
    sixDate.setMonth(sixDate.getMonth() - 12)
    let initDate = new Date('2022-07-13')

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    const labelStyle = {
        // display: "block",
        // float: "left",
        marginTop: "5px",
        // width: "100%",
        paddingTop: "5px",
        // marginLeft: '-3rem'
    }

    /*Propiedades de la tabla del componente*/
    const [rowData, setRowData] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [registros, setRegistros] = useState([]);

    const [isOpenH, setIsOpenH] = React.useState(false);

    const [historico, setHistorico] = useState([])
    const [params] = useParamsTracking();

    const [isOpenHProgram, setIsOpenHProgram] = React.useState(false);

    const [historicoProgram, setHistoricoProgram] = useState([])
    const [paramsProgram] = useParamsProgram();

    const [isOpenHNoProgram, setIsOpenHNoProgram] = React.useState(false);
    const [isOpenNoTurn, setIsOpenNoTurn] = React.useState(false);
    const [isOpenActivities, setIsOpenActivities] = useState(false)

    const [historicoNoProgram, setHistoricoNoProgram] = useState([])
    const [paramsNoProgram] = useParamsNoProgram();

    const [historicoNoTurn, setHistoricoNoTurn] = useState([])
    const [paramsNoTurn] = useParamsNoTurn()

    const [activities, setActivities] = useState([])
    const [paramsActivities] = useParamsActivities()

    const items = [
        {
            label: 'Marcaciones y turnos',
            icon: 'pi pi-arrow-right-arrow-left',
            // command: () => {
            //     showModalH()
            // },
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon} onClick={showModalH} className='p-button-xs text-sm w-full h-full' />
            }
        },
        {
            label: 'Programación de turnos',
            icon: 'pi pi-calendar-clock',
            // command: () => {
            //     showModalH()
            // },
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon} onClick={showModalHProgram} className='p-button-xs text-sm w-full h-full' />
            }
        },
        {
            label: 'Empleados sin turno o marcación',
            icon: 'pi pi-calendar-minus',
            // command: () => {
            //     showModalH()
            // },
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon} onClick={showModalHNoProgram} className='p-button-xs text-sm w-full h-full' />
            }
        },
        {
            label: 'Empleados sin programación de turnos',
            icon: 'pi pi-calendar-times',
            // command: () => {
            //     showModalH()
            // },
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon} onClick={showModalHNoTurn} className='p-button-xs text-sm w-full h-full' />
            }
        },
        {
            label: 'Reporte de actividades empleados',
            icon: 'pi pi-list-check',
            // command: () => {
            //     showModalH()
            // },
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon} onClick={showModalActivities} className='p-button-xs text-sm w-full h-full' />
            }
        },
    ]

    const items2 = [
        {
            label: 'Cargar turnos',
            icon: 'pi pi-upload',
            // command: () => {
            //     showModalH()
            // },
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon} className='p-button-success p-button-xs text-sm' onClick={() => showModalCargue()}/>
            }
        },
        {
            label: 'Cargar marcaciones',
            icon: 'pi pi-upload',
            // command: () => {
            //     showModalH()
            // },
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon}className='p-button-success p-button-xs text-sm' onClick={() => showModalCargueMarking()} />
            }
        },
        {
            label: 'Eliminar programaciones',
            icon: 'pi pi-times',
            // command: () => {
            //     showModalH()
            // },
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon} className='p-button-danger p-button-xs text-sm' onClick={() => showModalCargueDel()}/>
            }
        },
    ]

    useEffect(() => {
        /*Se inicializan las propiedades del componente para la generación de reportes*/
        const historicTemplate = async () => {
            let plantilla = []
            params.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setHistorico(plantilla)
        }
        historicTemplate()
    }, [params]);

    useEffect(() => {
        /*Se inicializan las propiedades del componente para la generación de reportes*/
        const historicTemplate = async () => {
            let plantilla = []
            paramsProgram.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setHistoricoProgram(plantilla)
        }
        historicTemplate()
    }, [paramsProgram]);

    useEffect(() => {
        /*Se inicializan las propiedades del componente para la generación de reportes*/
        const historicTemplate = async () => {
            let plantilla = []
            paramsNoProgram.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setHistoricoNoProgram(plantilla)
        }
        historicTemplate()
    }, [paramsNoProgram]);

    useEffect(() => {
        /*Se inicializan las propiedades del componente para la generación de reportes*/
        const historicTemplate = async () => {
            let plantilla = []
            paramsNoTurn.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setHistoricoNoTurn(plantilla)
        }
        historicTemplate()
    }, [paramsNoTurn]);

    useEffect(() => {
        /*Se inicializan las propiedades del componente para la generación de reportes*/
        const activitiesTemplate = async () => {
            let plantilla = []
            paramsActivities.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setActivities(plantilla)
        }
        activitiesTemplate()
    }, [paramsActivities]);

    useEffect(() => {
        shiftsLists("")
    }, [])

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const showModalCargue = () => {
        setIsOpenCargue(true);
    };

    const hideModalCargue = () => {
        setIsOpenCargue(false);
    };

    const showModalCargueDel = () => {
        setIsOpenCargueDel(true);
    };

    const hideModalCargueDel = () => {
        setIsOpenCargueDel(false);
    };

    const showModalH = () => {
        setIsOpenH(true);
    };

    const hideModalH = () => {
        setIsOpenH(false);
    };

    const showModalHProgram = () => {
        setIsOpenHProgram(true);
    };

    const hideModalHProgram = () => {
        setIsOpenHProgram(false);
    };

    const showModalHNoProgram = () => {
        setIsOpenHNoProgram(true);
    };

    const hideModalHNoProgram = () => {
        setIsOpenHNoProgram(false);
    };

    const showModalHNoTurn = () => {
        setIsOpenNoTurn(true);
    };

    const hideModalHNoTurn = () => {
        setIsOpenNoTurn(false);
    };

    const showModalCargueMarking = () => {
        setIsOpenCargueMarking(true);
    };

    const hideModalCargueMarking = () => {
        setIsOpenCargueMarking(false);
    };

    const showModalAdd = async () => {
        setLoadingAdd(true)
        let emp = ''
        if(registros.length === 1){
            addShiftLists(registros[0], "multiple")
        }
        registros.forEach(reg => {
            emp += reg.CONTRACT_ID + ' - ' + reg.NAME + '\n'
        })
        setEmployees(emp)
        setIsOpenAdd(true);
        setLoadingAdd(false)
    };

    const hideModalAdd = () => {
        setIsOpenAdd(false);
        setListaTurnosFilter([...listaTurnos])
    };

    const showModalActivities = () => {
        setIsOpenActivities(true);
    };

    const hideModalActivities = () => {
        setIsOpenActivities(false);
    };

    const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 100, value: 100 },
        { label: 200, value: 200 },
        { label: 300, value: 300 },
    ];

    const template2 = TablePaginator(dropdownOptions)

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
                </span>
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'JOB_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'DAY_CSO': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const header1 = renderHeader1();

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    const setTable = async (week, year = "") => {
        setHolidayList([])
        setHolidayType("")
        setLoadPage(false)
        console.log(week)
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _contract = "NULL"

        try {
            await apis.getShifts(_entity, _client, _contract, year, week.INIT_DT_WEEK, week.END_DT_WEEK, headers).then(res => {
                let _turnos = res.data.SHEDULES
                console.log(_turnos)
                setTurnos(_turnos)
                let turnosActivos = _turnos.filter(turno => turno.YEAR === fechaInicioCalendario.getFullYear().toString())[0]?.WEEKS
                console.log(turnosActivos)
                console.log(semana)
                let turnosSemana = turnosActivos ? turnosActivos.filter(turno => turno.WEEK === week.WEEK) : []
                if (turnosSemana.length > 0) {
                    console.log(turnosSemana)
                    setShifts(turnosSemana[0].CONTRACTS)
                }
                else {
                    setShifts([])
                }
                setLoading1(false)
                setLoadPage(true)
            })
        }
        catch (err) {
            console.log(err)
            setLoadPage(true)
            setLoading1(false)
        }
    }

    const addShiftLists = (rowData, type = "single") => {
        let _shifts = []
        _shifts = listaTurnos.filter(shift => shift.ENTITY === rowData.ENTITY && shift.CLIENT === rowData.CLIENT)
        console.log(_shifts)
        setListaTurnosFilter([..._shifts])
        setRowState({ ...rowState, [rowData.rowId]: false });
        if(type === "single"){
            setIsOpenAgregar(true)
        }
    }

    const shiftsLists = async (_year = "") => {
        const _entity = localStorage.getItem('entity')
        const _client = localStorage.getItem('client')
        const _contract = "NULL"

        try {
            await apis.getShiftsLists(_entity, _client, _contract, _year, headers).then(res => {
                let contracts = res.data.CONTRACTS
                let contracts_copy = []
                let entity_list = []
                let client_list = []
                let rowCounter = 0;
                let dataState = {}
                contracts.forEach(contract => {
                    let contract_copy = {
                        ...contract,
                        ROW_ID: rowCounter,
                        FULL_CONTRACT: contract.CONTRACT_ID + ' ' + contract.NAME + ' ' + contract.JOB_ID + ' ' + contract.ENTITY_NAME + ' ' + contract.CLIENT_NAME
                    }
                    dataState = {
                        ...dataState,
                        [rowCounter]: false
                    }
                    let entityIndex = entity_list.findIndex(ent => ent.CODE === contract.ENTITY)
                    if(entityIndex !== -1){
                        let ent = entity_list[entityIndex]
                        let clients = [...ent.CLIENTS]
                        if(!ent.CLIENTS.some(cli => cli.CODE === contract.CLIENT)){
                            let newClient = {
                                CODE: contract.CLIENT,
                                NAME: contract.CLIENT_NAME
                            }
                            clients.push(newClient)
                        }
                        ent = {
                            ...ent,
                            CLIENTS: [...clients]
                        }
                        entity_list[entityIndex] = ent
                    }
                    else{
                        let newClient = {
                            CODE: contract.CLIENT,
                            NAME: contract.CLIENT_NAME
                        }
                        let newEntity = {
                            CODE: contract.ENTITY,
                            NAME: contract.ENTITY_NAME,
                            CLIENTS: [newClient]
                        }
                        entity_list.push(newEntity)
                    }
                    dataState = {
                        ...dataState,
                        [rowCounter]: false
                    }
                    contracts_copy.push(contract_copy)
                    rowCounter++
                })
                setRowState({
                    ...rowState,
                    dataState
                })
                setClientList(client_list)
                setEntityList(entity_list)
                setRows(contracts_copy)
                setSelectedRows(contracts_copy)
                setContratos(contracts)
                let _turnos = res.data.SHIFTS
                let newTurnos = []
                _turnos.forEach(t => {
                    let newTurno = {
                        ...t,
                        LABEL: `${t.DESCRIPTION}`
                    }
                    newTurnos.push(newTurno)
                })
                let newYear = res.data.WEEKS[1].YEAR
                let yearDate = newYear < year ? res.data.WEEKS[1].END_DT_WEEK.split('-') : res.data.WEEKS[1].INIT_DT_WEEK.split('-')
                setYear(newYear)
                yearDate = yearDate[2] + "-" + yearDate[1] + '-' + yearDate[0]
                let currentDate = _year !== "" ? yearDate : new Date().toDateString()
                currentDate = Date.parse(currentDate)
                let currentWeek = res?.data?.WEEKS[1]?.WEEKS.filter(week => {
                    let splitDateInit = week.INIT_DT_WEEK.split('-')
                    let splitDateEnd = week.END_DT_WEEK.split('-')
                    console.log("Fechas: ", splitDateInit, splitDateEnd)
                    let _dateInit = splitDateInit[2] + '-' + splitDateInit[1] + '-' + splitDateInit[0]
                    let _dateEnd = splitDateEnd[2] + '-' + splitDateEnd[1] + '-' + splitDateEnd[0]
                    console.log("Comparación antes: ", currentDate, _dateInit, _dateEnd)
                    _dateInit = Date.parse(_dateInit)
                    _dateEnd = Date.parse(_dateEnd)
                    console.log("Comparación: ", currentDate, _dateInit, _dateEnd)
                    if (currentDate >= _dateInit && currentDate <= _dateEnd) {
                        return week
                    }
                })
                console.log("Semana actual: ", currentWeek)
                let _semana = {
                    ...currentWeek[0],
                    index: (parseInt(currentWeek[0].WEEK) - 1).toString()
                }
                console.log(currentWeek)
                setSemana({
                    ..._semana
                })
                setListaTurnos(newTurnos)
                setListaTurnosFilter(newTurnos)
                setSemanas(res?.data?.WEEKS[1]?.WEEKS)
                setNovedadesCalendario([])
                setTable(_semana, newYear)
                setCostCenterList(res.data.CENTRO_COSTO)
                setInvoiceCostCenterList(res.data.CEN_COST_FACT)
            })
        }
        catch (err) {
            console.log(err)
            setLoadPage(true)
            setLoading1(false)
        }
    }

    const addShift = async (contract, type = 'single') => {
        console.log(invoiceCostCenter)
        let dates = []
        for (const [key, value] of Object.entries(days)) {
            if (value !== "") {
                dates.push(value)
            }
        }

        let payload = {
            ENTITY: localStorage.getItem('entity'),
            CLIENT: localStorage.getItem('client'),
            CONTRACT_ID: contract,
            DATE_SHEDULE: dates,
            SHIFTS_ID: turno.ID,
            COST_CENTER_ID: costCenter.CENTER_ID,
            COST_CENTER_FACT_ID: invoiceCostCenter.CENTER_ID,
            TRK_TYPE_DAY: holidayType?.detail_id && holidayType.detail_id
        }
        try {
            await apis.postShift(payload, headers).then(res => {
                console.log(res.data.SHEDULES[0])
                setTable(semana, year)
                setLoading1(false)
                setIsOpenAgregar(false)
                if(type === 'single'){
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: `Turno creado exitosamente` });
                }
            })
        }
        catch (err) {
            setLoading1(false)
            if(type === 'single'){
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            }
            else{
                throw err
            }
        }
    }

    const removeShift = async () => {
        let shift_id = rowsTurno[0].PROGRAM_SHIFTS_ID
        try {
            await apis.deleteShift(localStorage.getItem('entity'), localStorage.getItem('client'), shift_id, headers).then(res => {
                let msg = `Turno ${shift_id} eliminado exitosamente. ` + (res.data.OBSERVATION ? res.data.OBSERVATION : '')
                setTable(semana, year)
                setLoading2(false)
                setIsOpenVer(false)
                setIsOpenEliminar(false)
                toast.current.show({ severity: 'info', summary: 'Éxito', detail: msg });
            })
        }
        catch (err) {
            setLoading2(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const addReplace = async () => {
        setLoadingReplace(true)
        console.log(rowsTurno)
        let payload = {
            ENTITY: localStorage.getItem('entity'),
            CLIENT: localStorage.getItem('client'),
            CONTRACT_ID: turno.CONTRACT_ID,
            PROGRAM_SHIFTS_ID: replaceType === 'individual' ? rowsTurno[0].PROGRAM_SHIFTS_ID : "",
            START_DATE: replaceType === 'multiple' ? dateFormat(replaceStart) : "",
            END_DATE: replaceType === 'multiple' ? dateFormat(replaceEnd) : "",
            CONTRACT_ID_REPLACE: replaceContract.CONTRACT_ID,
            LOV_CAUSAL: replaceCause.detail_id
        }
        if(replaceType === 'multiple' && replaceShifts.length > 0){
            payload = {
                ...payload,
                SHIFTS: replaceShifts
            }
        }
        try {
            await apis.postShiftReplace(payload, headers).then(res => {
                setTable(semana, year)
                setLoadingReplace(false)
                setIsOpenReplace(false)
                setIsOpenVer(false)
                setReplaceContract("")
                setReplaceCause("")
                setReplaceStart(new Date(Date.now()))
                setReplaceEnd(new Date(Date.now()))
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: `Reemplazo creado exitosamente` });
            })
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally {
            setLoadingReplace(false)
        }
    }

    const multipleSchedule = async () => {
        if (registros.length > 0) {
            setLoading7(true);
            let errors = [];
            let success = 0
            let fails = 0
            try {
                for (const contract of registros) {
                    try {
                        await addShift(contract.CONTRACT_ID, 'multiple').then(res => {
                            success += 1
                        })
                    } catch (err) {
                        fails += 1
                        console.log(err);
                        errors.push(`Contrato ${contract.CONTRACT_ID}: ` + err?.response?.data?.message);
                    }
                }
            } catch (error) {
                console.log(error);
                errors.push(error?.response?.data?.message);
            } finally {
                setLoading7(false);
                hideModalAdd();
                if (errors.length > 0) {
                    let msg = ['Se crearon los turnos:', `Exitosos: ${success}`, `Fallidos: ${fails}`, 'Se pueden validar los errores en el archivo descargado automáticamente "errores.txt"'].join('\n')
                    toast.current.show({ severity: 'warn', summary: 'Aviso', 
                        detail: (
                        <span style={{ whiteSpace: 'pre-line', textAlign: 'left', display: 'block' }}>
                            {msg}
                        </span>
                        )      
                        , sticky: true});
                    loadError(errors.join('\n'), 'errores.txt')
                } else {
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: `Turnos creados exitosamente` });
                }
            }
        }
    }
 
    const showConfirm = () => {
        /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
        toast.current.show({
            severity: 'info', sticky: consultado2, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i >
                            <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                        </i>
                        <p>Cargando información...</p>
                    </div>
                </div>
            )
        });
    }

    async function loadError(lines, name = 'ErroresCargue.txt') {
        /*Función encargada de gnerar el archivo txt de errores del cargue*/
        const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
        saveAs(blob, name);
    }

    async function downloadSampleFileCargue() {
        let payload = {
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            OPTION: 2
        }
        let sampleFile = []
        try {
            await apis.programShifts(payload, headers).then(res => {
                sampleFile = res.data
                let nombre = sampleFile["SHEETS"][0]["NAME"]
                // generateSampleFile(sampleFile, nombre)
                excelReport(sampleFile, nombre)
                setLoading4(false)
            });
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            setLoading4(false)
        }
    }

    async function importDataCargue(_importedData) {
        /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
        try {
            await apis.programShifts(_importedData, headers).then(res => {
                setConsultado2(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
                hideModalCargue()
                setTable(semana, year)
            })
        }
        catch (err) {
            loadError(err.response.data.message)
            setConsultado2(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
        }
    }

    async function downloadSampleFileCargueDel() {
        let payload = {
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            OPTION: 2
        }
        let sampleFile = []
        try {
            await apis.deleteProgramShifts(payload, headers).then(res => {
                sampleFile = res.data
                let nombre = sampleFile["SHEETS"][0]["NAME"]
                // generateSampleFile(sampleFile, nombre)
                excelReport(sampleFile, nombre)
                setLoading10(false)
            });
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            setLoading10(false)
        }
    }

    async function importDataCargueDel(_importedData) {
        /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
        try {
            await apis.deleteProgramShifts(_importedData, headers).then(res => {
                setConsultado3(false)
                toast.current.show({ severity: 'info', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
                hideModalCargueDel()
                setTable(semana, year)
            })
        }
        catch (err) {
            loadError(err.response.data.message)
            setConsultado3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al eliminar la(s) programación(es). Por favor revisar archivo de errores", sticky: true });
        }
    }

    async function importCargue(e) {
        setConsultado2(true);
        // showConfirm();

        const file = e.files[0]
        console.log(file)

        import('xlsx').then(xlsx => {
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];

                    const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });
                    data.shift();
                    const cleanData = data.filter(row =>
                        !row.every(cell => cell === null || cell === undefined || String(cell).trim() === '*' || String(cell).trim() === '')
                    );

                    const { formattedData, errors } = checkExcelData(cleanData)

                    if (errors.length > 0) {
                        const errorString = errors.join('\n')
                        setConsultado2(false)
                        loadError(errorString)
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Error en el formato de la información. Favor validar el archivo de errores.', sticky: true });
                        return;
                    }

                    let _importedData = {
                        NAME: "UploadAccumulated",
                        CLIENT: localStorage.getItem('client'),
                        ENTITY: localStorage.getItem('entity'),
                        OPTION: 1,
                        DETAIL: []
                    }

                    let lines = 1
                    formattedData.forEach(row => {
                        let _line = row.join("|")
                        _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
                        lines++
                    })

                    importDataCargue(_importedData)

                } catch (err) {
                    setConsultado2(false)
                    console.error(err)
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al cargar la información. Por favor revisar archivo de errores', sticky: true });
                }
            };
            reader.readAsArrayBuffer(file);
        });
    }

    async function importCargueDel(e) {
        setConsultado3(true);
        // showConfirm();

        const file = e.files[0]
        console.log(file)

        import('xlsx').then(xlsx => {
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];

                    const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });
                    data.shift();
                    const cleanData = data.filter(row =>
                        !row.every(cell => cell === null || cell === undefined || String(cell).trim() === '*' || String(cell).trim() === '')
                    );

                    const { formattedData, errors } = checkExcelData(cleanData)

                    if (errors.length > 0) {
                        const errorString = errors.join('\n')
                        setConsultado3(false)
                        loadError(errorString)
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Error en el formato de la información. Favor validar el archivo de errores.', sticky: true });
                        return;
                    }

                    let _importedData = {
                        NAME: "UploadDelete",
                        CLIENT: localStorage.getItem('client'),
                        ENTITY: localStorage.getItem('entity'),
                        OPTION: 1,
                        DETAIL: []
                    }

                    let lines = 1
                    formattedData.forEach(row => {
                        let _line = row.join("|")
                        _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
                        lines++
                    })

                    importDataCargueDel(_importedData)

                } catch (err) {
                    setConsultado3(false)
                    console.error(err)
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al cargar la información. Por favor revisar archivo de errores', sticky: true });
                }
            };
            reader.readAsArrayBuffer(file);
        });
    }

    async function postTrackingReport() {

        /*Función encargada de cargar la informacion para generar el reporte de histótico de ausentismos*/
        let finalReport = []
        const client = localStorage.getItem('client')
        const entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        historico.forEach(h => {
            let size = h.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        historico.forEach(h => {
            h.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
            })
        })
        try {
            await apis.exportTurns(report, headers).then(res => {
                finalReport = res.data
                // generateReportedReport(finalReport, "reporteTurnosYMarcaciones")
                excelReport(finalReport, "reporteTurnosYMarcaciones")
                setLoading5(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de turnos y maraciones generado existosamente" });
                hideModalH();
            })
        }
        catch (err) {
            setLoading5(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function postProgramReport() {

        /*Función encargada de cargar la informacion para generar el reporte de histótico de ausentismos*/
        let finalReport = []
        const client = localStorage.getItem('client')
        const entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        historicoProgram.forEach(h => {
            let size = h.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        historicoProgram.forEach(h => {
            h.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
            })
        })
        try {
            await apis.exportProgram(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, "reporteProgramacion")
                setLoading5(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de programación de turnos generado existosamente" });
                hideModalHProgram();
            })
        }
        catch (err) {
            setLoading5(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function postNoProgramReport() {

        /*Función encargada de cargar la informacion para generar el reporte de histótico de ausentismos*/
        let finalReport = []
        const client = localStorage.getItem('client')
        const entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        historicoNoProgram.forEach(h => {
            let size = h.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        historicoNoProgram.forEach(h => {
            h.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
            })
        })
        try {
            await apis.exportNoProgram(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, "reporteSinMarcacionOTurnos")
                setLoading5(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de empleados sin turnos o marcación generado existosamente" });
                hideModalHNoProgram();
            })
        }
        catch (err) {
            setLoading5(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function postNoTurnReport() {

        /*Función encargada de cargar la informacion para generar el reporte de histótico de ausentismos*/
        let finalReport = []
        const client = localStorage.getItem('client')
        const entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        historicoNoTurn.forEach(h => {
            let size = h.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        historicoNoTurn.forEach(h => {
            h.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
            })
        })
        try {
            await apis.exportNoTurn(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, "reporteSinProgramacionTurnos")
                setLoading5(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de empleados sin programación de turnos generado existosamente" });
                hideModalHNoTurn();
            })
        }
        catch (err) {
            setLoading5(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function postActivitiesReport() {

        /*Función encargada de cargar la informacion para generar el reporte de histótico de ausentismos*/
        let finalReport = []
        const client = localStorage.getItem('client')
        const entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        activities.forEach(h => {
            let size = h.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        activities.forEach(h => {
            h.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
            })
        })
        try {
            await apis.exportActivities(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, "reporteActividadesEmpleados")
                setLoading9(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de actividades empleados generado existosamente" });
                hideModalActivities();
            })
        }
        catch (err) {
            setLoading9(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function downloadSampleFileCargueMarking() {
        let payload = {
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            OPTION: 2
        }
        let sampleFile = []
        try {
            await apis.postMarking(payload, headers).then(res => {
                sampleFile = res.data
                let nombre = sampleFile["SHEETS"][0]["NAME"]
                // generateSampleFile(sampleFile, nombre)
                excelReport(sampleFile, nombre)
                setLoading6(false)
            });
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            setLoading6(false)
        }
    }

    async function importDataCargueMarking(_importedData) {
        /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
        try {
            await apis.postMarking(_importedData, headers).then(res => {
                setConsultado2(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
                hideModalCargueMarking()
                // setTable(semana, year)
            })
        }
        catch (err) {
            loadError(err.response.data.message)
            setConsultado2(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
        }
    }

    async function importCargueMarking(e) {
        /*Función encargada de formatear los datos del archivo Excel para subirlos*/
        setConsultado2(true);
        // showConfirm();
        const file = e.files[0]
        console.log(file)

        import('xlsx').then(xlsx => {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    console.log(ws)
                    const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });
                    // Prepare DataTable
                    console.log(data)
                    data.shift();
                    const cleanData = data.filter(row =>
                        !row.every(cell => cell === null || cell === undefined || String(cell).trim() === '*' || String(cell).trim() === '')
                    );

                    const { formattedData, errors } = checkExcelData(cleanData)

                    if (errors.length > 0) {
                        const errorString = errors.join('\n')
                        setConsultado2(false)
                        loadError(errorString)
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Error en el formato de la información. Favor validar el archivo de errores.', sticky: true });
                        return;
                    }

                    let _importedData = {
                        NAME: "UploadMarking",
                        CLIENT: localStorage.getItem('client'),
                        ENTITY: localStorage.getItem('entity'),
                        OPTION: 1,
                        DETAIL: []
                    }

                    let lines = 1
                    console.log(data)
                    formattedData.forEach(row => {
                        let _line = row.join("|")
                        _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
                        lines++
                    })

                    importDataCargueMarking(_importedData)

                } catch (err) {
                    setConsultado2(false)
                    console.error(err)
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al cargar la información. Por favor revisar archivo de errores', sticky: true });
                }
            };
            reader.readAsArrayBuffer(file);
        });
    }

    const onChange = (e) => {
        console.log(e.value)
        setRegistros(e.value)
        let news = []
        e.value.forEach(element => {
            let nov = novedades.filter((n) => n.CONTRACT_ID === element.CONTRACT_ID)
            nov.forEach(newNov => {
                news.push(newNov)
            })
        })
        setNovedadesCalendario(news)
    }

    const applyFilters = (entity_, client_) => {
        let filtered = selectedRows.map(row => ({
            ...row
        }));
    
        if (entity_) {
            filtered = filtered.filter(row => row.ENTITY === entity_.CODE);
        }
    
        if (client_) {
            filtered = filtered.filter(row => row.CLIENT === client_.CODE);
        }
        setRows(filtered);
    };  

    const filterByEntity = (entity_) => {
        setEntity(entity_);
        setClient("")
        setClientList(entity_?.CLIENTS ? entity_.CLIENTS : [])
        applyFilters(entity_, entity_  ? client : undefined);
    };

    const filterByClient = (client_) => {
        setClient(client_);
        applyFilters(entity, client_ ? client_ : undefined);
    };

    const leftToolbarTemplate = () => {
        let dateArray = []
        for (const [key, value] of Object.entries(days)) {
            if (value !== "") {
                dateArray.push(value)
            }
        }
        const leftClassName = 'flex align-content-center flex-wrap gap-2 ' + (width > 768 ? 'flex-row' : 'flex-column')
        return (
            <div className={leftClassName}>
                {/* <label style={labelStyle}>Seleccione un año</label>
                &nbsp; */}
                <Calendar id="navigators" value={fechaInicio}
                    onChange={(e) => {
                        setFechaInicio(e.value);
                        setLoadPage(false)
                        shiftsLists(e.value.getFullYear().toString())
                    }}
                    locale="es" dateFormat="yy" view='year' yearRange="1900:2150" showIcon style={elementWidth}
                    placeholder="Seleccione un año" tooltip='Seleccione un año' tooltipOptions={{position: 'top'}}
                />
                <SplitButton icon='pi pi-upload' model={items2} label='Cargues' text={false} className='report-button p-button-xs text-sm p-button-success' menuClassName='novelties' />
                <SplitButton icon='pi pi-file-excel' model={items} label='Reportes' text={false} className='report-button p-button-xs text-sm' menuClassName='novelties' />
                <Button label='Agregar turno' className='p-button-success p-button-xs text-sm' loading={loading8}
                    icon='pi pi-plus' onClick={() => postHolidayList(registros, dateArray, 'multiple')}
                    disabled={Object.values(days).every(x => x === '') || registros.length === 0}
                />
            </div>
        )
    }

    const leffFilterBar = () => {
        const msg = "Para filtrar la información, seleccione una empresa.\n Esto habilitará los clientes pertenecientes a dicha empresa\n y se podrá realizar el filtro por ambos campos"
        const leftClassName = 'flex align-content-center align-items-end gap-2 ' + (width > 768 ? 'flex-row' : 'flex-column')
        return(
            <div className={leftClassName}>
                <Tooltip target=".info" className='indigo-tooltip ml-1'/>
                <div className='flex flex-row align-items-center gap-2'>
                    {width > 374 && <i className="info pi pi-info-circle cursor-pointer" data-pr-tooltip={msg} data-pr-position='bottom'
                        data-pr-classname="text-primary" style={{ color: '#00a8ff', fontSize: '1.2rem' }} />}
                    <Dropdown value={entity} options={entityList} onChange={(e) => filterByEntity(e.value)} optionLabel="NAME" showClear
                        placeholder="Empresa" style={{ width: '15rem' }} tooltip={entity?.NAME} tooltipOptions={{position: 'top'}}/>
                </div>
                <Dropdown value={client} options={clientList} onChange={(e) => filterByClient(e.value)} optionLabel="NAME" showClear disabled={!entity}
                    placeholder="Cliente" style={{ width: '15rem' }} tooltip={client?.NAME} tooltipOptions={{position: 'top'}}/>
            </div>
        )
    }

    const changeWeek = (value) => {

        // let currentYear = fechaInicio.getFullYear();
        let currentYear = parseInt(semana.END_DT_WEEK.split('-')[2]);
        let newWeek = value;
        let newYear = currentYear;
        let isYearChanged = false;

        if (value === 0) {
            newWeek = 52;
            newYear = currentYear - 1;
            isYearChanged = true;
        } else if (value > 52) {
            newWeek = 1;
            newYear = currentYear + 1;
            isYearChanged = true;
        }

        console.log("Year:", newYear, "Week:", newWeek);

        if (isYearChanged) {
            setLoadPage(false)
            setFechaInicio(new Date(newYear, 0, 1));
            shiftsLists(newYear.toString());
        }

        else {

            let newIndex = newWeek - 1;
            let updatedWeek = semanas[newIndex];

            // if (turnos.length > 0) {
            //     let newTurnos = turnos.filter(turno => newYear.toString() === turno.YEAR.toString());
            //     let turnosSemana = newTurnos.length > 0
            //         ? newTurnos[0].WEEKS.filter(turno => newWeek.toString() === turno.WEEK)
            //         : [];

            //     if (turnosSemana.length > 0) {
            //         setShifts(turnosSemana[0].CONTRACTS);
            //     }
            //     else {
            //         setShifts([]);
            //     }
            // }
            // else {
            //     setShifts([]);
            // }

            setTable(updatedWeek, newYear)

            setSemana({
                ...semana,
                ...updatedWeek,
                index: newIndex,
            });
        }
    };

    const replaceList = async (type, id = "NULL") => {
        setReplaceType(type)
        const _client = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')
        const start = type === 'multiple' ? dateFormat(replaceStart) : "NULL"
        const end = type === 'multiple' ? dateFormat(replaceEnd) : "NULL"
        const _contract = turno.CONTRACT_ID

        try {
            await apis.shiftReplaceList(_entity, _client, id, start, end, _contract, headers).then(res => {
                setReplaceContracts(res.data?.CONTRACTS)
                setReplaceInfo(res.data?.TRK_REPLACE_CAUSAL)
                setReplaceShiftsList(res.data?.SHIFTS)
                setIsOpenReplace(true)
                setIsOpenReplaceDate(false)
            })
        }
        catch (err) {
            console.log(err)
        }
        finally {
            setLoadReplace(false)
        }
    }

    const postHolidayList = async (rows, dates, type) => {
        console.log("Sicsas", type, rows)
        if(type === 'multiple'){
            setLoading8(true)
        }
        else{
            setRowState({
                ...rowData,
                [rows[0].ROW_ID]: true
            })
        }
        let errors = [];
        let responses = []
        let success = 0
        let fails = 0
        try{
            for (const row of rows){
                let payload = {
                    ENTITY: localStorage.getItem('entity'),
                    CLIENT: localStorage.getItem('client'),
                    CONTRACT_ID: row.CONTRACT_ID,
                    DATE_SHEDULE: dates
                }
                try {
                    await apis.postHolidayList(payload, headers).then(res => {
                        success += 1
                        responses.push({
                            ...res.data,
                            CONTRACT_ID: row.CONTRACT_ID 
                        })
                    })
                } catch (err) {
                    fails += 1
                    console.log(err);
                    errors.push(`Contrato ${row.CONTRACT_ID}: ` + err?.response?.data?.message);
                }
            }
        }
        catch(error){
            console.log(error);
            errors.push(error?.response?.data?.message);
        }
        finally {
            if(errors.length > 0){
                if(errors.length > 1){
                    toast.current.show({ severity: 'warn', summary: 'Aviso', 
                        detail: "Se presentan errores. Por favor validalos en el archivo errores.txt", sticky: true});
                    loadError(errors.join('\n'), 'errores.txt')
                }
                else{
                    toast.current.show({ severity: 'warn', summary: 'Aviso', 
                        detail: "Error: "+errors[0], sticky: true});
                }
            }
            else{
                if (responses.length > 1) {
                    let validationErrors = ["Los empleados seleccionados, no cumplen la misma condición de parametrización: "]
                    let areEqual = true
                    const validate = responses[0]
                    for(const resp of responses){
                        validationErrors.push("El contrato "+resp.CONTRACT_ID+" tiene parámetro: "+resp.VALIDATE)
                        if(resp.VALIDATE !== validate.VALIDATE){
                            areEqual = false
                        }
                    }
                    if(!areEqual){
                        toast.current.show({ severity: 'warn', summary: 'Aviso', 
                        detail: "Los empleados seleccionados, no cumplen la misma condición de parametrización. Por favor validar en el archivo errores.txt", sticky: true});
                        loadError(validationErrors.join('\n'))
                    }
                    else{
                        if(validate.VALIDATE === 'S'){
                            setHolidayList(validate.TRK_TYPE_DAY)
                        }
                        showModalAdd(rows)
                    }
                }
                else{
                    const validate = responses[0]
                    if(validate.VALIDATE === 'S'){
                        setHolidayList(validate.TRK_TYPE_DAY)
                    }
                    setTurno({
                        CONTRACT_ID: rows[0].CONTRACT_ID
                    });
                    setCostCenter({})
                    setInvoiceCostCenter({})
                    setFechas(dates)
                    setNombre(rows[0].NAME)
                    setIsOpenAgregar(true)
                }
            }
            if(type === 'multiple'){
                setLoading8(false)
            }
            else{
                 setRowState({
                    ...rowData,
                    [rows[0].ROW_ID]: false
                })
            }
        }
    } 

    const weekOptionTemplate = (option) => {
        return (
            <div className="flex align-items-start justify-content-start text-left" style={{ width: '6rem' }}>
                {option.WEEK}
            </div>
        );
    };

    const rightElements = [
        <Button icon='pi pi-angle-double-left' rounded text onClick={() => changeWeek(parseInt(semana.WEEK) - 1)} />,
        <label className='flex align-self-center'>Semana</label>,
        <Dropdown options={semanas} value={semana} optionLabel='WEEK' placeholder={semana ? semana.WEEK : ""} style={{ width: '6rem' }}
            filter filterBy='WEEK'
            onChange={(e) => changeWeek(parseInt(e.value.WEEK))}
            itemTemplate={weekOptionTemplate}
            className='select'
        />,
        <label className='flex align-self-center'>{semana.INIT_DT_WEEK} a {semana.END_DT_WEEK}</label>,
        <Button icon='pi pi-angle-double-right' rounded text onClick={() => changeWeek(parseInt(semana.WEEK) + 1)} />,
    ]

    const rightToolbarTemplate = () => {
        return (
            <div className='left-tb flex align-content-center gap-3'>
                {width > 768 ?
                    rightElements.map(element => {
                        return element
                    })
                    :
                    <div className='flex flex-column align-content-center gap-2 mt-2'>
                        {rightElements[1]}
                        <div className='flex flex-row'>
                            {rightElements[0]}
                            {rightElements[2]}
                            {rightElements[4]}
                        </div>
                        {rightElements[3]}
                    </div>
                }
            </div>
        )
    }

    const photoBodyTemplate = (rowData) => {
        const photo = rowData.IMAGES ? rowData.IMAGES : process.env.REACT_APP_PROFILE_PIC;
        let dates = ""
        let dateArray = []
        for (const [key, value] of Object.entries(days)) {
            if (value !== "") {
                dates += `${key}; `
                dateArray.push(value)
            }
        }
        setFechas(dates)
        return (
            <div className='flex flex-row align-items-center justify-content-between gap-1'>
                <div
                    style={{
                        width: '50px',
                        height: '50px',
                        minWidth: '50px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        flexShrink: 0
                    }}
                >
                    <img
                        src={photo}
                        alt=""
                        loading="eager"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                </div>
                <div className='flex flex-column ml-2 text-left w-full'>
                    <span className='font-bold'>{rowData.NAME}</span>
                    <span>{rowData.CONTRACT_ID} - {rowData.JOB_ID}</span>
                    <span><span className='font-bold'>Empresa: </span>{rowData.ENTITY_NAME}</span>
                    <span><span className='font-bold'>Cliente: </span>{rowData.CLIENT_NAME}</span>
                </div>
                <Button
                    size='small'
                    className='p-button-success p-button-xs text-xs'
                    disabled={Object.values(days).every(x => x === '')}
                    icon='pi pi-plus'
                    loading={rowState[rowData.ROW_ID]}
                    onClick={async () => {
                        setRowState({ ...rowState, [rowData.ROW_ID]: true });
                        setTurno({
                            CONTRACT_ID: rowData.CONTRACT_ID
                        });
                        setCostCenter({})
                        setInvoiceCostCenter({})
                        setFechas(dates)
                        setNombre(rowData.NAME)
                        postHolidayList([rowData], dateArray, 'single')
                    }}
                />
                <Button
                    size='small'
                    className='p-button-info p-button-xs text-xs'
                    icon='pi pi-sync'
                    tooltip='Reemplazar'
                    onClick={() => {
                        setTurno({
                            CONTRACT_ID: rowData.CONTRACT_ID
                        });
                        setReplaceStart(new Date(Date.now()))
                        setReplaceEnd(new Date(Date.now()))
                        setIsOpenReplaceDate(true)
                        setCostCenter({})
                        setInvoiceCostCenter({})
                        setFechas(dates)
                        setNombre(rowData.NAME)
                    }}
                />
            </div>
        );
    }

    const calculateDate = (date, days = 0) => {
        let splitDate = date.split('-')
        let _date = splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]
        let newDate = new Date(_date)
        newDate.setDate(newDate.getDate() + days + 1)
        newDate = newDate.toLocaleDateString("es-CL")
        return newDate
    }

    const daysTemplate = (rowData, date, days = 0) => {
        let newDate = calculateDate(date, days)
        let cellData = []
        let newCellData = []
        if (shifts) {
            cellData = shifts.filter((contract) => contract.CONTRACT_ID === rowData.CONTRACT_ID)
            if (cellData.length > 0) {
                newCellData = cellData[0].SCHEDULES.filter((t) => t.DATE_SHEDULE === newDate)
            }
        }
        return (
            <div className='flex align-content-start flex-column gap-1'>
                {
                    newCellData.length > 0 && newCellData.map(cell => {
                        let turnInfo = cell.START_TIME + ' - ' + cell.END_TIME
                        return (
                            <span 
                                onClick={() => {
                                    setTurno({
                                        ...turno,
                                        CONTRACT_ID: rowData.CONTRACT_ID
                                    })
                                    setRowsTurno([cell]);
                                    setIsOpenVer(true);
                                    console.log("Turno", cell)
                            }}>
                                <Tag className={'info ' + (cell.REST_DAY === 'S' ? 'rest' : "")}
                                    data-pr-tooltip={cell.MESSAGE ? cell.MESSAGE : ""}
                                    icon='pi pi-clock' value={turnInfo} style={{ height: '2rem', width: '8rem' }} rounded 
                                    severity={cell.CONTRACT_ID_REPLACE ? 'warning' : cell.CONTRACT_ID_REPLACED ? 'success' : 'info'}
                                 />
                            </span>
                        )
                    })
                }
            </div>
        )
    }

    const headerTemplate = (day, date) => {
        return (
            <div className='flex gap-1'>
                <span>{day}</span>
                <Checkbox
                    disabled={contratos.length === 0}
                    inputId="binary"
                    checked={days[day] !== ""}
                    onChange={() => {
                        setDays({
                            ...days,
                            [day]: days[day] === "" ? date : ""
                        })
                    }}
                />
            </div>
        )
    }

    const addFooter = (
        <div>
            <Button onClick={() => {setIsOpenAgregar(false); setHolidayList([])}}>Cancelar</Button>
            <Button onClick={() => { setLoading1(true); addShift(turno.CONTRACT_ID) }} loading={loading1} label='Guardar'></Button>
        </div>
    );

    const addHeader = (
        <div>
            <h3>Agregar turno</h3>
        </div>
    );

    const infoFooter = (
        <div className='flex flex-row justify-content-between'>
            <Button onClick={() => { setLoadReplace(true); setIsOpenReplace(true); replaceList('individual', rowsTurno[0].PROGRAM_SHIFTS_ID) }} label='Reemplazar'></Button>
            <div>
                <Button onClick={() => setIsOpenVer(false)} label='Cerrar'></Button>
                <Button onClick={() => setIsOpenEliminar(true)} loading={loading1} label='Eliminar'></Button>
            </div>
        </div>
    );

    const infoHeader = (
        <div>
            <h3>Detalles turno</h3>
        </div>
    );

    const deleteFooter = (
        <div>
            <Button onClick={() => setIsOpenEliminar(false)} label='Cancelar'></Button>
            <Button onClick={() => { setLoading2(true); removeShift() }} loading={loading2} label='Eliminar'></Button>
        </div>
    );

    const deleteHeader = (
        <div>
            <h3>¿Desea eliminar el turno?</h3>
        </div>
    );

    const replaceFooter = (
        <div>
            <Button onClick={() => {
                setIsOpenReplace(false);
                setReplaceContract("")
                setReplaceCause("")
            }}
                label='Cancelar'></Button>
            <Button onClick={() => { addReplace() }} loading={loadingReplace} label='Reemplazar'
                disabled={!replaceCause || !replaceContract || (replaceType === 'multiple' ? (replaceShifts.length === 0 ? true : false) : false ) } 
            ></Button>
        </div>
    );

    const replaceHeader = (
        <div>
            <h3>Reemplazar turno</h3>
        </div>
    );

    const dateFooter = (
        <div>
            <Button onClick={() => {
                setIsOpenReplaceDate(false);
                setReplaceStart(new Date(Date.now()))
                setReplaceEnd(new Date(Date.now()))
            }}
                label='Cancelar'></Button>
            <Button onClick={() => {
                setLoadReplace(true)
                replaceList('multiple')
            }}
                label='Continuar' loading={loadReplace}></Button>
        </div>
    );

    const dateHeader = (
        <div>
            <h3>Fechas de reemplazo</h3>
        </div>
    );

    const footerHS = (
        <div>
            <Button label='Generar' loading={loading5} onClick={() => { setLoading5(true); postTrackingReport() }} />
        </div>
    );

    const headerHS = (
        <div>
            <h3>Parámetros reporte turnos y marcaciones</h3>
        </div>
    )

    const footerHSProgram = (
        <div>
            <Button label='Generar' loading={loading5} onClick={() => { setLoading5(true); postProgramReport() }} />
        </div>
    );

    const headerHSProgram = (
        <div>
            <h3>Parámetros reporte programación de turnos</h3>
        </div>
    )

    const footerHSNoProgram = (
        <div>
            <Button label='Generar' loading={loading5} onClick={() => { setLoading5(true); postNoProgramReport() }} />
        </div>
    );

    const headerHSNoProgram = (
        <div>
            <h3>Parámetros reporte empleados sin turno o marcación</h3>
        </div>
    )

    const footerHSNoTurn = (
        <div>
            <Button label='Generar' loading={loading5} onClick={() => { setLoading5(true); postNoTurnReport() }} />
        </div>
    );

    const headerHSNoTurn = (
        <div>
            <h3>Parámetros reporte empleados sin programación de turnos</h3>
        </div>
    )

    const footerActivities = (
        <div>
            <Button label='Generar' loading={loading9} onClick={() => { setLoading9(true); postActivitiesReport() }} />
        </div>
    );

    const headerActivities = (
        <div>
            <h3>Parámetros reporte actividades</h3>
        </div>
    )

    const optionTemplate = (option) => {
        return (
            <div className="flex align-items-start justify-content-start text-left" style={{ whiteSpace: 'pre-line', width: '20rem' }}>
                {option.LABEL}
            </div>
        );
    };

    const optionCostTemplate = (option) => {
        return (
            <div className="flex align-items-start justify-content-start text-left" style={{ whiteSpace: 'pre-line', width: '20rem' }}>
                {option.CENTER_NAME}
            </div>
        );
    };


    const footerCargue = (
        <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
            <Button style={{ marginLeft: "-6rem" }} label='Cancelar' disabled={consultado2} onClick={() => { setLoading4(false); hideModalCargue() }} />
            <Button type="button" icon="pi pi-file-excel" label="Plantilla" disabled={consultado2} loading={loading4} onClick={() => { setLoading4(true); downloadSampleFileCargue() }} />
            {!consultado2 ? <FileUpload ref={fileUploadRef} disabled={consultado2} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importCargue}>
            </FileUpload> :
                <Button loading={consultado2} label='Cargar' icon='pi pi-upload' />
            }
        </div>
    );

    const footerCargueDel = (
        <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
            <Button style={{ marginLeft: "-6rem" }} label='Cancelar' disabled={consultado3} onClick={() => { setLoading10(false); hideModalCargueDel() }} />
            <Button type="button" icon="pi pi-file-excel" label="Plantilla" disabled={consultado3} loading={loading10} onClick={() => { setLoading10(true); downloadSampleFileCargueDel() }} />
            {!consultado3 ? <FileUpload ref={fileUploadRef} disabled={consultado3} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importCargueDel}>
            </FileUpload> :
                <Button loading={consultado3} label='Cargar' icon='pi pi-upload' />
            }
        </div>
    );

    const footerCargueMarking = (
        <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
            <Button style={{ marginLeft: "-6rem" }} label='Cancelar' disabled={consultado2} onClick={() => { setLoading6(false); hideModalCargueMarking() }} />
            <Button type="button" icon="pi pi-file-excel" label="Plantilla" disabled={consultado2} loading={loading6} onClick={() => { setLoading6(true); downloadSampleFileCargueMarking() }} />
            {!consultado2 ? <FileUpload ref={fileUploadRef} disabled={consultado2} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importCargueMarking}>
            </FileUpload> :
                <Button loading={consultado2} label='Cargar' icon='pi pi-upload' />
            }
        </div>
    );

    const footerAdd = (
        <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
            <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading7(false); hideModalAdd() }} />
            <Button type="button" label="Aceptar" loading={loading7} onClick={() => { setLoading7(true); multipleSchedule() }} />
        </div>
    );

    const optionReplaceTemplate = (option) => {
        const foto = option.IMAGES ? option.IMAGES : process.env.REACT_APP_PROFILE_PIC
        return (
            <div className='flex flex-row align-items-center justify-content-start gap-1'>
                <img alt={""} src={foto} width={50} height={50} style={{ verticalAlign: 'middle', borderRadius: '40px' }} />
                <div className='flex flex-column ml-2 text-left w-full align-content-start'>
                    <span className='font-bold'>{option.NAME}</span>
                    <span>{option.CONTRACT_ID} - {option.JOB_ID}</span>
                </div>
            </div>
        );
    };

    const valueReplaceTemplate = (value) => {
        const _value = value ? value.CONTRACT_ID + " - " + value.NAME : 'Seleccione'
        return (
            <span>{_value}</span>
        )
    }

    const headerCargue = (
        <div>
            <h3>Cargar turnos</h3>
        </div>
    )

    const headerCargueDel = (
        <div>
            <h3>Eliminar programaciones</h3>
        </div>
    )

    /*Funciones que manejan el cambio en los campos de entrada del modal de generación del reporte*/
    function handleChangeH(e, d, index) {
        setHistorico(h => {
            let newHistorico = [...h]
            console.log(index)
            console.log(h)
            newHistorico[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeDateH(e, d, index) {
        console.log(e.value)
        let date = dateFormat(e.value)
        setHistorico(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeTextH(e, d, index) {
        console.log(e.value)
        setHistorico(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    function handleChangeHProgram(e, d, index) {
        setHistoricoProgram(h => {
            let newHistorico = [...h]
            console.log(index)
            console.log(h)
            newHistorico[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeDateHProgram(e, d, index) {
        console.log(e.value)
        let date = dateFormat(e.value)
        setHistoricoProgram(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeTextHProgram(e, d, index) {
        console.log(e.value)
        setHistoricoProgram(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    function handleChangeHNoProgram(e, d, index) {
        setHistoricoNoProgram(h => {
            let newHistorico = [...h]
            console.log(index)
            console.log(h)
            newHistorico[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeDateHNoProgram(e, d, index) {
        console.log(e.value)
        let date = dateFormat(e.value)
        setHistoricoNoProgram(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeTextHNoProgram(e, d, index) {
        console.log(e.value)
        setHistoricoNoProgram(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    function handleChangeHNoTurn(e, d, index) {
        setHistoricoNoTurn(h => {
            let newHistorico = [...h]
            console.log(index)
            console.log(h)
            newHistorico[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeDateHNoTurn(e, d, index) {
        console.log(e.value)
        let date = dateFormat(e.value)
        setHistoricoNoTurn(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeTextHNoTurn(e, d, index) {
        console.log(e.value)
        setHistoricoNoTurn(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    function handleChangeActivities(e, d, index) {
        setActivities(h => {
            let newHistorico = [...h]
            console.log(index)
            console.log(h)
            newHistorico[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeDateActivites(e, d, index) {
        console.log(e.value)
        let date = dateFormat(e.value)
        setActivities(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    async function handleChangeTextActivities(e, d, index) {
        console.log(e.value)
        setActivities(h => {
            let newHistorico = [...h]
            newHistorico[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newHistorico
        })
    }

    const headerCargueMarking = (
        <div>
            <h3>Cargar marcaciones</h3>
        </div>
    )

    return (
        <div className='surface-100 px-4 py-5 md:px-6 lg:px-8r'>
            <Dialog header={addHeader} footer={addFooter} visible={isOpenAgregar} position="top" style={{ width: "26rem" }} draggable={false} 
             resizable={false} modal onHide={() => {setIsOpenAgregar(false); setListaTurnosFilter([...listaTurnos]); setHolidayList([])}}>
                <div className='flex flex-column'>
                    <label style={labelStyle}>Empleado</label>
                    <InputText value={nombre} disabled />
                    <label style={labelStyle}>Días</label>
                    <InputText value={fechas} disabled />
                    <label style={labelStyle}>Semana</label>
                    <InputText value={semana.WEEK + ": " + semana.INIT_DT_WEEK + ' a ' + semana.END_DT_WEEK} disabled />
                    <label style={labelStyle}>Turno</label>
                    <Dropdown options={listaTurnosFilter} optionLabel='LABEL' value={turno} onChange={(e) => setTurno({ ...turno, ...e.value })}
                        autofocus filter showClear filterBy="LABEL" emptyMessage={"No hay turnos disponibles"}
                        placeholder={turno ? turno.LABEL : 'Seleccione'} itemTemplate={optionTemplate}
                    />
                    <label style={labelStyle}>Centro de costo contable</label>
                    <Dropdown options={costCenterList} optionLabel='CENTER_NAME' value={costCenter} onChange={(e) => setCostCenter({ ...e.value })}
                        autofocus filter showClear filterBy="CENTER_NAME" emptyMessage={"No hay turnos disponibles"}
                        placeholder={costCenter ? costCenter.CENTER_NAME : 'Seleccione'} itemTemplate={optionCostTemplate}
                    />
                    <label style={labelStyle}>Centro de costo facturable</label>
                    <Dropdown options={invoiceCostCenterList} optionLabel='CENTER_NAME' value={invoiceCostCenter} onChange={(e) => setInvoiceCostCenter({ ...e.value })}
                        autofocus filter showClear filterBy="CENTER_NAME" emptyMessage={"No hay turnos disponibles"}
                        placeholder={invoiceCostCenter ? invoiceCostCenter.CENTER_NAME : 'Seleccione'} itemTemplate={optionCostTemplate}
                    />
                    {holidayList.length > 0 && <>
                        <label style={labelStyle}>¿Cómo debe ser compensado?</label>
                        <Dropdown options={holidayList} optionLabel='description' value={holidayType} onChange={(e) => setHolidayType({ ...e.value })}
                            autofocus filter showClear filterBy="description" emptyMessage={"No hay opciones disponibles"}
                            placeholder={holidayType ? holidayType.description : 'Seleccione'}
                        />
                    </>}
                </div>
            </Dialog>
            <Dialog header={addHeader} footer={footerAdd} visible={isOpenAdd} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={() => hideModalAdd()}>
                <div className='flex flex-column'>
                    <label style={labelStyle}>Empleados</label>
                    <InputTextarea value={employees} contentEditable={false} />
                    <label style={labelStyle}>Días</label>
                    <InputText value={fechas} disabled />
                    <label style={labelStyle}>Semana</label>
                    <InputText value={semana.WEEK + ": " + semana.INIT_DT_WEEK + ' a ' + semana.END_DT_WEEK} disabled />
                    <label style={labelStyle}>Turno</label>
                    <Dropdown options={listaTurnosFilter} optionLabel='LABEL' value={turno} onChange={(e) => setTurno({ ...turno, ...e.value })}
                        autofocus filter showClear filterBy="LABEL" emptyMessage={"No hay turnos disponibles"}
                        placeholder={turno ? turno.LABEL : 'Seleccione'} itemTemplate={optionTemplate}
                    />
                    <label style={labelStyle}>Centro de costo contable</label>
                    <Dropdown options={costCenterList} optionLabel='CENTER_NAME' value={costCenter} onChange={(e) => setCostCenter({ ...e.value })}
                        autofocus filter showClear filterBy="CENTER_NAME" emptyMessage={"No hay turnos disponibles"}
                        placeholder={costCenter ? costCenter.CENTER_NAME : 'Seleccione'} itemTemplate={optionCostTemplate}
                    />
                    <label style={labelStyle}>Centro de costo facturable</label>
                    <Dropdown options={invoiceCostCenterList} optionLabel='CENTER_NAME' value={invoiceCostCenter} onChange={(e) => setInvoiceCostCenter({ ...e.value })}
                        autofocus filter showClear filterBy="CENTER_NAME" emptyMessage={"No hay turnos disponibles"}
                        placeholder={invoiceCostCenter ? invoiceCostCenter.CENTER_NAME : 'Seleccione'} itemTemplate={optionCostTemplate}
                    />
                    {holidayList.length > 0 && <>
                        <label style={labelStyle}>¿Cómo debe ser compensado?</label>
                        <Dropdown options={holidayList} optionLabel='description' value={holidayType} onChange={(e) => setHolidayType({ ...e.value })}
                            autofocus filter showClear filterBy="description" emptyMessage={"No hay opciones disponibles"}
                            placeholder={holidayType ? holidayType.description : 'Seleccione'}
                        />
                    </>}
                </div>
            </Dialog>
            {rowsTurno.length > 0 && <Dialog header={infoHeader} footer={infoFooter} visible={isOpenVer} position="top" style={{ width: width > 768 ? "32rem" : "100%" }} draggable={false} resizable={false} modal onHide={() => setIsOpenVer(false)}>
                <span style={{ marginBottom: '5rem' }}><span style={{ fontWeight: 'bold' }}>Turno: </span>{rowsTurno[0].SHIFTS_ID}</span><br />
                <span style={{ marginBottom: '5rem' }}><span style={{ fontWeight: 'bold' }}>Fecha: </span>{rowsTurno[0].DATE_SHEDULE}</span><br />
                {rowsTurno[0].COST_CENTER_ID && <><span style={{ marginBottom: '5rem' }}><span style={{ fontWeight: 'bold' }}>Centro de costo contable: </span>{rowsTurno[0].COST_CENTER_ID.split('|')[1]}</span><br /></>}
                {rowsTurno[0].COST_CENTER_FAC_ID && <><span style={{ marginBottom: '5rem' }}><span style={{ fontWeight: 'bold' }}>Centro de costo facturable: </span>{rowsTurno[0].COST_CENTER_FAC_ID.split('|')[1]}</span><br /></>}
                {rowsTurno[0].STATUS && <><span style={{ marginBottom: '5rem' }}><span style={{ fontWeight: 'bold' }}>Estado de la programación: </span>{rowsTurno[0].STATUS.split('|')[1]}</span><br /></>}
                {rowsTurno[0].CONTRACT_ID_REPLACE && <><span style={{ marginBottom: '5rem' }}><span style={{ fontWeight: 'bold' }}>Contrato que reemplaza la programación: </span>{rowsTurno[0].CONTRACT_ID_REPLACE}</span><br /></>}
                {rowsTurno[0].CONTRACT_ID_REPLACED && <><span style={{ marginBottom: '5rem' }}><span style={{ fontWeight: 'bold' }}>Contrato que reemplaza la programación: </span>{rowsTurno[0].CONTRACT_ID_REPLACED}</span><br /></>}
                {rowsTurno[0].OBSERVATION && <><span style={{ marginBottom: '5rem', textAlign: 'justify', textDecoration: 'underline', textDecorationColor: 'darkblue', color: 'darkblue', width: '100%', display: 'block' }}>
                    <span style={{ fontWeight: 'bold', color: 'black' }}>Observación: </span>{rowsTurno[0].OBSERVATION}</span></>}
                {(rowsTurno[0].TRK_TYPE_DAY && rowsTurno[0].TRK_TYPE_DAY !== '|') && 
                <><span style={{ marginBottom: '5rem' }}><span style={{ fontWeight: 'bold' }}>¿Cómo debe ser compensado?: </span>{rowsTurno[0].TRK_TYPE_DAY.split('|')[1]}</span></>}
                <DataTable className="text-xs" value={rowsTurno} scrollable scrollDirection='horizontal'
                    dataKey="CONTRACT_ID" size="small" style={{ width: '100%', marginTop: '2rem' }}>
                    <Column field="START_TIME_REAL" header="Hora inicio"></Column>
                    <Column field="END_TIME_REAL" header="Hora fin"></Column>
                    <Column field="RDF" header="RDF"></Column>
                    <Column field="RN" header="RN"></Column>
                    <Column field="HED" header="HED"></Column>
                    <Column field="HEDF" header="HEDF"></Column>
                    <Column field="HEN" header="HEN"></Column>
                    <Column field="HENF" header="HENF"></Column>
                    <Column field="TOTAL_RN" header="Total RN"></Column>
                    <Column field="TOTAL_HE" header="Total HE"></Column>
                </DataTable>
            </Dialog>}
            <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={() => setIsOpenEliminar(false)} />
            <Dialog header={headerCargue} footer={footerCargue} visible={isOpenCargue} closable={!consultado2}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalCargue}>
                <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
                <br />
                <span>2. Diligencie la hoja Modelo de Cargue con la información de los turnos que desea programar a sus empleados.</span>
                <br />
                <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
            </Dialog>
            <Dialog header={headerCargueDel} footer={footerCargueDel} visible={isOpenCargueDel} closable={!consultado3}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalCargueDel}>
                <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
                <br />
                <span>2. Diligencie la hoja Modelo de Cargue con la información de la(s) programación(es) de turnos que desea eliminar.</span>
                <br />
                <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
            </Dialog>
            <Dialog header={headerCargueMarking} footer={footerCargueMarking} visible={isOpenCargueMarking} closable={!consultado2}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalCargueMarking}>
                <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
                <br />
                <span>2. Diligencie la hoja Plantilla Cargue marcación con la información de las marcaciones que desea cargar.</span>
                <br />
                <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
            </Dialog>
            <Dialog header={replaceHeader} footer={replaceFooter} visible={isOpenReplace} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={() => setIsOpenReplace(false)}>
                {loadReplace ? <ProgressSpinner /> :
                    <div className='flex flex-column'>
                        <label style={labelStyle}>Causal reemplazo</label>
                        <Dropdown options={replaceInfo} optionLabel='description' value={replaceCause} onChange={(e) => setReplaceCause(e.value)}
                            autofocus filter showClear filterBy="description" emptyMessage={"No hay causales disponibles"}
                            placeholder={replaceCause ? replaceCause.description : 'Seleccione'}
                        />
                        <label style={labelStyle}>Contrato reemplazo</label>
                        <Dropdown options={replaceContracts} optionLabel='NAME' value={replaceContract} panelClassName='replace' onChange={(e) => setReplaceContract(e.value)}
                            autofocus filter showClear filterBy="NAME" emptyMessage={"No hay contratos disponibles"} valueTemplate={valueReplaceTemplate}
                            placeholder={'Seleccione'} itemTemplate={optionReplaceTemplate}
                        />
                        {replaceType === 'multiple' && <div className='flex gap-1 flex-column'>
                            <label style={labelStyle}>Turnos a reemplazar</label>
                            {
                                replaceShiftsList?.length > 0 && replaceShiftsList.map(shift => {
                                    return(
                                        <div className='flex gap-1 align-items-center'>
                                            <span style={{...labelStyle, fontSize: '14px'}}>{shift.DESCRIPTION}</span>
                                            <Checkbox
                                                value={shift.SHIFTS_ID}
                                                inputId={shift.SHIFTS_ID}
                                                checked={replaceShifts.includes(shift.SHIFTS_ID)}
                                                onChange={() => {
                                                    if(!replaceShifts.includes(shift.SHIFTS_ID)){
                                                        setReplaceShifts([...replaceShifts, shift.SHIFTS_ID])
                                                        console.log(replaceShifts)
                                                    }
                                                    else{
                                                        setReplaceShifts(replaceShifts.filter(s => s !== shift.SHIFTS_ID))
                                                    }
                                                }}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>}
                    </div>}
            </Dialog>
            <Dialog header={dateHeader} footer={dateFooter} visible={isOpenReplaceDate} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={() => setIsOpenReplaceDate(false)}>
                <div className='flex flex-column'>
                    <label style={labelStyle}>Fecha inicio reemplazo</label>
                    <Calendar id="navigators" value={replaceStart}
                        onChange={(e) => {
                            setReplaceStart(e.value);
                        }}
                        locale="es" dateFormat="dd-mm-yy" yearRange="1900:2150" showIcon
                        placeholder="Seleccione un mes"
                    />
                    <label style={labelStyle}>Fecha fin reemplazo</label>
                    <Calendar id="navigators" value={replaceEnd}
                        onChange={(e) => {
                            setReplaceEnd(e.value);
                        }}
                        locale="es" dateFormat="dd-mm-yy" yearRange="1900:2150" showIcon
                        placeholder="Seleccione un mes"
                    />
                </div>
            </Dialog>
            <Dialog header={headerHS} footer={footerHS} visible={isOpenH}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalH}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span><br /><br />
                {params.map((d, index) => {
                    /*Generación dinámica de los parámetros para la generación del reporte histórico de HE y recargos*/
                    if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && historico.length > 0 && typeof historico[index] !== "undefined") {
                        let label = d.LABEL;
                        if (d.REQUIRED === "1") {
                            label = label + "*"
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = []
                                if (d.REQUIRED === "1") {
                                    options = [...d.OPTIONS]
                                }
                                else {
                                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                }
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={historico[index]["NAME"]}
                                        options={options}
                                        filter showClear filterBy="NAME"
                                        optionLabel="NAME"
                                        emptyMessage={"No hay " + label + "s disponibles"}
                                        //optionTemplate={optionTemplate}
                                        placeholder={historico[index]["NAME"] ? historico[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChangeH(e, d, index)}
                                    />
                                    <br />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <Calendar key={d} style={elementWidth} id="navigators" value={historico[index].CODE}
                                        onChange={(e) => handleChangeDateH(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={historico[index].CODE}
                                        yearRange="2010:2030" /><br /></>
                                );
                            default:
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <InputText
                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"
                                        value={historico[index]}
                                        onChange={(e) => handleChangeTextH(e, d, index)}
                                    /><br /></>
                                )
                        }
                    }
                })}
            </Dialog>
            <Dialog header={headerHSProgram} footer={footerHSProgram} visible={isOpenHProgram}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalHProgram}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span><br /><br />
                {paramsProgram.map((d, index) => {
                    /*Generación dinámica de los parámetros para la generación del reporte histórico de HE y recargos*/
                    if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && historicoProgram.length > 0 && typeof historicoProgram[index] !== "undefined") {
                        let label = d.LABEL;
                        if (d.REQUIRED === "1") {
                            label = label + "*"
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = []
                                if (d.REQUIRED === "1") {
                                    options = [...d.OPTIONS]
                                }
                                else {
                                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                }
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={historicoProgram[index]["NAME"]}
                                        options={options}
                                        filter showClear filterBy="NAME"
                                        optionLabel="NAME"
                                        emptyMessage={"No hay " + label + "s disponibles"}
                                        //optionTemplate={optionTemplate}
                                        placeholder={historicoProgram[index]["NAME"] ? historicoProgram[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChangeHProgram(e, d, index)}
                                    />
                                    <br />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <Calendar key={d} style={elementWidth} id="navigators" value={historicoProgram[index].CODE}
                                        onChange={(e) => handleChangeDateHProgram(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={historicoProgram[index].CODE}
                                        yearRange="2010:2030" /><br /></>
                                );
                            default:
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <InputText
                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"
                                        value={historicoProgram[index]}
                                        onChange={(e) => handleChangeTextHProgram(e, d, index)}
                                    /><br /></>
                                )
                        }
                    }
                })}
            </Dialog>
            <Dialog header={headerHSNoProgram} footer={footerHSNoProgram} visible={isOpenHNoProgram}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalHNoProgram}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span><br /><br />
                {paramsNoProgram.map((d, index) => {
                    /*Generación dinámica de los parámetros para la generación del reporte histórico de HE y recargos*/
                    if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && historicoNoProgram.length > 0 && typeof historicoNoProgram[index] !== "undefined") {
                        let label = d.LABEL;
                        if (d.REQUIRED === "1") {
                            label = label + "*"
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = []
                                if (d.REQUIRED === "1") {
                                    options = [...d.OPTIONS]
                                }
                                else {
                                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                }
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={historicoNoProgram[index]["NAME"]}
                                        options={options}
                                        filter showClear filterBy="NAME"
                                        optionLabel="NAME"
                                        emptyMessage={"No hay " + label + "s disponibles"}
                                        //optionTemplate={optionTemplate}
                                        placeholder={historicoNoProgram[index]["NAME"] ? historicoNoProgram[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChangeHNoProgram(e, d, index)}
                                    />
                                    <br />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <Calendar key={d} style={elementWidth} id="navigators" value={historicoNoProgram[index].CODE}
                                        onChange={(e) => handleChangeDateHNoProgram(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={historicoNoProgram[index].CODE}
                                        yearRange="2010:2030" /><br /></>
                                );
                            default:
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <InputText
                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"
                                        value={historicoNoProgram[index]}
                                        onChange={(e) => handleChangeTextHNoProgram(e, d, index)}
                                    /><br /></>
                                )
                        }
                    }
                })}
            </Dialog>
            <Dialog header={headerHSNoTurn} footer={footerHSNoTurn} visible={isOpenNoTurn}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalHNoTurn}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span><br /><br />
                {paramsNoTurn.map((d, index) => {
                    /*Generación dinámica de los parámetros para la generación del reporte histórico de HE y recargos*/
                    if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && historicoNoTurn.length > 0 && typeof historicoNoTurn[index] !== "undefined") {
                        let label = d.LABEL;
                        if (d.REQUIRED === "1") {
                            label = label + "*"
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = []
                                if (d.REQUIRED === "1") {
                                    options = [...d.OPTIONS]
                                }
                                else {
                                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                }
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={historicoNoTurn[index]["NAME"]}
                                        options={options}
                                        filter showClear filterBy="NAME"
                                        optionLabel="NAME"
                                        emptyMessage={"No hay " + label + "s disponibles"}
                                        //optionTemplate={optionTemplate}
                                        placeholder={historicoNoTurn[index]["NAME"] ? historicoNoTurn[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChangeHNoTurn(e, d, index)}
                                    />
                                    <br />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <Calendar key={d} style={elementWidth} id="navigators" value={historicoNoTurn[index].CODE}
                                        onChange={(e) => handleChangeDateHNoTurn(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={historicoNoTurn[index].CODE}
                                        yearRange="2010:2030" /><br /></>
                                );
                            default:
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <InputText
                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"
                                        value={historicoNoTurn[index]}
                                        onChange={(e) => handleChangeTextHNoTurn(e, d, index)}
                                    /><br /></>
                                )
                        }
                    }
                })}
            </Dialog>
            <Dialog header={headerActivities} footer={footerActivities} visible={isOpenActivities}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalActivities}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span><br /><br />
                {paramsActivities.map((d, index) => {
                    /*Generación dinámica de los parámetros para la generación del reporte histórico de HE y recargos*/
                    if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && activities.length > 0 && typeof activities[index] !== "undefined") {
                        let label = d.LABEL;
                        if (d.REQUIRED === "1") {
                            label = label + "*"
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = []
                                if (d.REQUIRED === "1") {
                                    options = [...d.OPTIONS]
                                }
                                else {
                                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                }
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={activities[index]["NAME"]}
                                        options={options}
                                        filter showClear filterBy="NAME"
                                        optionLabel="NAME"
                                        emptyMessage={"No hay " + label + "s disponibles"}
                                        //optionTemplate={optionTemplate}
                                        placeholder={activities[index]["NAME"] ? activities[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChangeActivities(e, d, index)}
                                    />
                                    <br />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <Calendar key={d} style={elementWidth} id="navigators" value={activities[index].CODE}
                                        onChange={(e) => handleChangeDateActivites(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={activities[index].CODE}
                                        yearRange="2010:2030" /><br /></>
                                );
                            default:
                                return (<>
                                    <span htmlFor="label">{label}</span>
                                    <br />
                                    <InputText
                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"
                                        value={activities[index]}
                                        onChange={(e) => handleChangeTextActivities(e, d, index)}
                                    /><br /></>
                                )
                        }
                    }
                })}
            </Dialog>
            <Toast ref={toast} />
            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
                <span className="text-900">Semana Mi Equipo</span>
            </div>
            <div className='mt-6 w-full'>
                <SkeletonTable load={loadPage}>
                    <Toolbar end={leffFilterBar} className='card flex flex-row' />
                    <Toolbar start={leftToolbarTemplate} end={rightToolbarTemplate} className='card week flex flex-row' />
                    <div className="thing">
                        <Tooltip target=".info" className='indigo-tooltip ml-1'/>
                        {rows && <DataTable className="card text-xs" value={rows} first={first2} rows={rows2} scrollable scrollDirection='horizontal'
                            selectionMode="multiple" selection={registros} onSelectionChange={(e) => onChange(e)} dataKey="CONTRACT_ID"
                            size="small" style={{ width: '100%' }} paginator paginatorTemplate={template2} filterLocale='es'>
                            <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>
                            <Column header="Empleados" field='FULL_CONTRACT' filterMatchModeOptions={matchModes} body={photoBodyTemplate} style={{ width: '24rem' }} filter></Column>
                            <Column field="Lunes" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK)} header={() => headerTemplate("Lunes", calculateDate(semana.INIT_DT_WEEK))}></Column>
                            <Column field="Martes" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK, 1)} header={() => headerTemplate("Martes", calculateDate(semana.INIT_DT_WEEK, 1))}></Column>
                            <Column field="Miercóles" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK, 2)} header={() => headerTemplate("Miércoles", calculateDate(semana.INIT_DT_WEEK, 2))}></Column>
                            <Column field="Jueves" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK, 3)} header={() => headerTemplate("Jueves", calculateDate(semana.INIT_DT_WEEK, 3))}></Column>
                            <Column field="Viernes" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK, 4)} header={() => headerTemplate("Viernes", calculateDate(semana.INIT_DT_WEEK, 4))}></Column>
                            <Column field="Sábado" body={(data) => daysTemplate(data, semana.INIT_DT_WEEK, 5)} header={() => headerTemplate("Sábado", calculateDate(semana.INIT_DT_WEEK, 5))}></Column>
                            <Column field="Domingo" body={(data) => daysTemplate(data, semana.END_DT_WEEK)} header={() => headerTemplate("Domingo", calculateDate(semana.END_DT_WEEK))}></Column>
                        </DataTable>}
                    </div>
                </SkeletonTable>
            </div>
        </div>
    )

}

export default TeamWeek